import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
// import { securityActions } from '@src/store/reducers/securityReducer';
import { AuthService } from '@src/services';
//  import { Store } from '@src/store';
// import { userActions } from '@src/store/reducers/userReducer';

// import $ from 'jquery';

@Component({
    selector: 'oidc-configuration',
    template: require('./oidc-configuration.html'),
    styles: [require('./oidc-configuration.scss')]
})
export class OidcConfigurationComponent implements OnInit {
    public hasItems = false;
    public selectedDomain: any;
    public testSuccess:boolean;
    public AutType:string;
    public configurationTestStatus:string = ''
    @Input() public oidcConf : any;

    @Output() public onUpdate = new EventEmitter();

   // private unSubscribe: any;

    constructor(private authService: AuthService){}

    async ngOnInit() {
        this.AutType = JSON.parse(localStorage.getItem('AuthType'));
        // const action = { type: securityActions.GET_OIDC_COfIGURATIONS};
        // const response = await this.store.dispatch(action);
        // this.oidcConf = response.data
        // console.log(this.configProprties)
        // this.GroupsMapping = this.configProprties.GroupsMapping 
    }

    public setDataConfig(fieldName:string,data:string){
         let newInser = {fieldName:fieldName,data:data} 
         this.onUpdate.emit(newInser)
    }

    public async testConfig(){
       // const tokenCreted = await this.authService.testConnection()
       const tokenCreted = await this.authService.testConnection(this.oidcConf)
       if(tokenCreted){
        this.testSuccess = true
       }
       else {
        this.testSuccess = false
       }
       this.configurationTestStatus = this.testSuccess ? 'Success' : 'Failed';
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/usersRolesManagement/advancedManagement/oidc-configuration/oidc-configuration/oidc-configuration.ts